var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateJobTabIconTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30155 12.1125L6.8878 15.6988C8.3603 17.1713 10.7511 17.1713 12.2316 15.6988L15.707 12.2233C17.1795 10.7508 17.1795 8.36001 15.707 6.87959L12.1128 3.30126C11.3607 2.54918 10.3236 2.14542 9.2628 2.20084L5.30447 2.39084C3.72113 2.46209 2.46238 3.72084 2.38322 5.29626L2.19322 9.25459C2.14572 10.3233 2.54947 11.3604 3.30155 12.1125Z",
    stroke: "#253D87",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52116 9.49984C8.61422 9.49984 9.50033 8.61373 9.50033 7.52067C9.50033 6.42761 8.61422 5.5415 7.52116 5.5415C6.4281 5.5415 5.54199 6.42761 5.54199 7.52067C5.54199 8.61373 6.4281 9.49984 7.52116 9.49984Z",
    stroke: "#253D87",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateJobTabIconTags);
export default __webpack_public_path__ + "static/media/create_job_tab_icon_tags.896c916692ce38e8e55ca9d8375e75b0.svg";
export { ForwardRef as ReactComponent };